import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from "vue";
import { useStore } from "@/stores";
import { isEmptyOrWhiteSpace } from "@/utils/Common";
import { useRouter } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'DContainerLayout',
  props: {
  navTitle: { type: String, default: "" },
  showBack: { type: Boolean, default: false },
  bodyCls: { type: String, default: "" },
},
  setup(__props) {

const props = __props;



const store = useStore();
const router = useRouter();

const projectInfo = computed(() => (store.state as any).project.info);

const showNav = computed(() => {
  const project = projectInfo.value;
  return project && !isEmptyOrWhiteSpace(project.name);
});

const currentNavTitle = computed(() => store.state.currentNavTitle);

watch(
  () => props.navTitle,
  () => {
    store.commit("currentNavTitle", props.navTitle);
  }
);

function goBack() {
  router.back();
}

return { __sfc: true,props, store, router, projectInfo, showNav, currentNavTitle, goBack }
}

})